/** @format */

import { AdBannerData } from '../types';
import adBanner0 from '../assets/adBanner/mainBanner2@2x.png';
import adBanner2 from '../assets/adBanner/adbanner-2@2x.png';

const testbed = process.env.REACT_APP_BUILD === 'tbed' ? '-test' : '';
export const adBannerData: Record<number, AdBannerData> = {
	0: {
		id: 0,
		order: 0,
		title: '신한은행 실명인증 서비스가 종료되었습니다.',
		subTitle: '',
		img: adBanner0,
		link: 'notice?id=1',
		bgColor: 'rgb(228, 247, 255)',
	},
	1: {
		id: 1,
		order: 1,
		title: '쯩 서비스가 종료될 예정입니다. ',
		subTitle: '',
		img: adBanner2,
		link: 'notice?id=0',
		bgColor: 'rgb(234, 237, 255)',
	},
};
